import { render, staticRenderFns } from "./RequisicaoDetalhes.vue?vue&type=template&id=f0120924&"
import script from "./RequisicaoDetalhes.vue?vue&type=script&lang=js&"
export * from "./RequisicaoDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports